import React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: auto;
  height: 2.75rem;
`;
export default function Tec() {
  return (
    <Wrapper
      width="690"
      height="512"
      viewBox="0 0 690 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M468.884 405.558C468.884 405.099 468.838 404.657 468.817 404.211H589.343C644.762 404.211 689.853 359.12 689.853 303.701C689.853 269.806 672.96 238.438 644.657 219.781L468.792 103.853C365.722 35.9116 245.987 0 122.543 0H0V216.926H542.4L614.998 264.779C628.122 273.432 635.958 287.979 635.958 303.701C635.958 329.406 615.048 350.316 589.343 350.316H0V404.211H199.478C199.457 404.657 199.411 405.099 199.411 405.558C199.411 425.608 206.762 443.962 218.897 458.105H0V512H78.1474H132.042H238.484H292.379H396.126H450.021H559.158H613.053H689.853V458.105H449.398C461.533 443.962 468.884 425.608 468.884 405.558ZM53.8947 53.8947H122.543C144.737 53.8947 166.787 55.1832 188.632 57.6926V163.032H53.8947V53.8947ZM242.526 163.032V66.5095C312.232 81.3432 378.8 109.086 439.124 148.846L460.64 163.032H242.526ZM414.989 405.558C414.989 420.417 402.901 432.505 388.042 432.505C373.183 432.505 361.095 420.417 361.095 405.558C361.095 405.099 361.048 404.657 361.027 404.211H415.057C415.036 404.657 414.989 405.099 414.989 405.558ZM307.267 404.211C307.246 404.657 307.2 405.099 307.2 405.558C307.2 420.417 295.112 432.505 280.253 432.505C265.394 432.505 253.305 420.417 253.305 405.558C253.305 405.099 253.259 404.657 253.238 404.211H307.267Z"
        className="fill"
      />
    </Wrapper>
  );
}
